export const cvData = {
  personal: {
    name: 'Yesh Jitesh',
    title: 'Doctor of Medicine | GP Assistant & Clinical Administrator | Medical Coder',
    email: 'contact@dryeshjitesh.com',
    phone: '+44-7392060569',
    location: 'Harrow, London, United Kingdom',
    linkedin: 'https://www.linkedin.com/in/dryeshjitesh',
    instagram: 'https://www.instagram.com/dryeshjitesh?igsh=amtkOXJiZm4xMGVp',
  },
  about:
    'Results-driven Doctor of Medicine with over four years of progressive NHS primary care experience spanning clinical support, GP assistance, medical coding, clinical audit, and practice administration. Proficient in EMIS Web, DOCMAN, Anima, SystmOne, and the full Microsoft Office suite, with proven skill in designing EMIS templates for structured chronic disease reviews and building QOF-aligned audits that improve register compliance.\n\nI manage end-to-end disease reviews across Asthma, COPD, Diabetes, Hypertension, and CKD — including spirometry, 24-hour ABPM, referral coordination, and management planning — and code accurately in SNOMED CT, Read Codes, and ICD-10. Beyond the clinic, I am the founder of RotaCare UK, an AI-powered NHS workforce management platform, reflecting a wider commitment to operational innovation and strategic leadership in healthcare.',
  languages: ['English', 'Hindi', 'Gujarati'],
  hobbies: ['Music', 'Swimming', 'Table tennis', 'Guitar', 'Adventure', 'Movies', 'Spending time with family and friends'],
  education: [
    {
      degree: 'Doctor of Medicine (M.D)',
      institution: 'University of the Visayas - Gullas College of Medicine',
      location: 'Cebu, Philippines',
      year: 2021,
    },
    {
      degree: 'Bachelor of Science - Major in Biological Sciences',
      institution: 'Southwestern University - Phinma',
      location: 'Cebu, Philippines',
      year: 2017,
    },
  ],
  experience: [
    {
      title: 'GP Assistant & Medical Administrator',
      company: 'Wembley Park Medical Centre (NHS CQC-Registered Practice)',
      location: 'Wembley, London',
      startDate: 'Apr 2023',
      endDate: 'Present',
      responsibilities: [
        'Provide comprehensive clinical support to GPs including patient assessments, vital sign recording, diagnostic preparations, ECG recording and interpretation, phlebotomy, and chaperoning.',
        'Run and coordinate dedicated disease review clinics: Asthma (spirometry, inhaler technique, written action plans), COPD (MRC dyspnoea scale, exacerbation history, spirometry review), Diabetes (HbA1c, foot checks, retinopathy recall, medication review), and Hypertension/BP (24-hour ABPM setup and interpretation, medication titration support).',
        'Set up and operate 24-hour Ambulatory Blood Pressure Monitoring (ABPM) — fitting devices, instructing patients, downloading and coding results into EMIS.',
        'Manage the end-to-end referral process: identify referral need, complete e-Referral / NHS 18-week pathway forms, produce referral letters via DOCMAN, track outcomes, and code responses to patient records.',
        'Design and maintain EMIS Web templates for structured chronic disease reviews, ensuring consistent, coded, and audit-ready data capture.',
        'Lead QOF audit cycles: extract patient lists via EMIS reporting, identify exception-reported and non-compliant patients, action recalls, and update registers to maximise achievement.',
        'Support new CRM and patient recall system implementation — configuring recall templates, population segmentation, and automated messaging workflows to improve review uptake.',
        'Perform accurate clinical coding using EMIS Web (SNOMED CT / Read Codes), ensuring data integrity for QOF, Enhanced Services, PCN DES, and CCG/ICB reporting.',
        'Produce clinical PDF reports, governance documents, and practice templates — including the authored CQC protocol WPMC-CG-ECG-001 (ECG Recording & Management).',
        'Process and code incoming clinical correspondence via DOCMAN; draft summaries, letters, and reports for GPs.',
        'Administer and manage repeat prescriptions in line with practice policy and Safe Prescribing protocols.',
        'Manage patient scheduling via Anima, optimise appointment templates, and support front-desk operations to reduce wait times.',
        'Ensure compliance with NHS Information Governance, GDPR, and CQC requirements across all clinical and administrative activity.',
        'Collaborate across a multidisciplinary team (GPs, nurses, pharmacists, receptionists, PCN staff) to deliver safe, efficient, patient-centred care.',
      ],
    },
    {
      title: 'Clinical & GP Assistant',
      company: 'Brentfield Medical Centre (NHS Practice)',
      location: 'Brent, London',
      startDate: 'May 2022',
      endDate: 'Apr 2023',
      responsibilities: [
        'Supported GPs with medical assessments, clinical coding, consultation summaries, and diagnosis and management planning.',
        'Delivered Asthma review clinics: spirometry, peak flow monitoring, inhaler technique assessment, RCP 3-question symptom scoring, and written action plans.',
        'Delivered COPD review clinics: spirometry, MRC dyspnoea grading, exacerbation history review, and management plan updates in EMIS.',
        'Conducted Diabetic clinic workups: HbA1c review, lifestyle counselling, foot and eye referral recall, and medication review support.',
        'Operated 24-hour ABPM clinics — device fitting, patient education, results download, and coding into EMIS.',
        'Produced referral letters, clinical summaries, and PDF documents using DOCMAN and Microsoft Word.',
        'Performed phlebotomy, wound care, suture removal, vaccination and immunisation, and infection control procedures.',
        'Maintained accurate, coded patient records in EMIS; managed administrative workflows to NHS IG and GDPR standards.',
      ],
    },
    {
      title: 'Healthcare Assistant',
      company: 'Brentfield Medical Centre',
      location: 'Brent, London',
      startDate: 'May 2022',
      endDate: 'Apr 2023',
      responsibilities: [
        'Recorded and monitored patient vital signs; assisted clinical staff during examinations and procedures.',
        'Ran blood clinics, vaccination clinics, NHS Health Check appointments, and 24-hour BP clinics.',
        'Provided patient education, emotional support, and care navigation guidance.',
      ],
    },
    {
      title: 'Trainee HCA & Clinical Assistant',
      company: 'Brentfield Medical Centre',
      location: 'Brent, London',
      startDate: 'Apr 2022',
      endDate: 'May 2022',
      responsibilities: [
        'Completed structured induction in clinical and administrative workflows within a busy NHS GP practice.',
      ],
    },
    {
      title: 'COVID-19 Vaccination Coordinator',
      company: 'Mandaue Health Department',
      location: 'Cebu, Philippines',
      startDate: 'Apr 2021',
      endDate: 'May 2021',
      responsibilities: [
        'Administered COVID-19 vaccines per established protocols; screened patients for eligibility and contraindications.',
        'Maintained accurate electronic vaccination records and provided patient education on vaccine safety.',
      ],
    },
    {
      title: 'Medical Intern / Clerkship',
      company: 'Gullas College of Medicine',
      location: 'Cebu, Philippines',
      startDate: 'Aug 2020',
      endDate: 'Jul 2021',
      responsibilities: [
        'Completed supervised rotations across internal medicine, surgery, paediatrics, OB-GYN, and emergency medicine.',
        'Participated in ward rounds, case presentations, clinical assessments, and procedural assistance.',
        'Developed clinical history-taking, diagnostic reasoning, and patient management skills under consultant supervision.',
      ],
    },
  ],
  skills: {
    clinical: [
      'Spirometry & Respiratory Assessment',
      '24-hour Ambulatory BP Monitoring (ABPM)',
      'Asthma, COPD, Diabetes & Hypertension Reviews',
      'CKD, LD & SMI Screening',
      'ECG Recording & Interpretation',
      'Phlebotomy & Vaccination',
      'NHS Health Checks',
      'Wound Care & Minor Procedures',
    ],
    administrative: [
      'Clinical Coding (SNOMED CT / Read Codes / ICD-10)',
      'EMIS Web — Templates, Reporting & Audits',
      'DOCMAN, Anima & SystmOne',
      'NHS e-Referral Service (e-RS)',
      'QOF & Enhanced Services Compliance',
      'CRM & Patient Recall Systems',
      'PDF Clinical Report Production',
      'Repeat Prescription Management',
    ],
    professional: [
      'Leadership & Team Training',
      'NHS Information Governance & GDPR',
      'Safeguarding Adults & Children (Level 3)',
      'Clinical Audit & Workflow Optimisation',
      'Multidisciplinary Collaboration',
      'Patient Communication',
      'Problem Solving & Decision Making',
      'Operational Innovation',
    ],
  },
  courses: [
    'ECG — Interpretation & Diagnosis',
    'Asthma & COPD — Diagnosis and Management',
    'Diabetes Care for Healthcare Professionals',
    'Hypertension — Diagnosis and Management',
    'Phlebotomy',
    'Wound Care',
    'Catheter Care',
    'Tracheostomy Care',
    'Basic Life Support (Adult, Children, Infant)',
    'Anaphylaxis Recognition & Management',
    'Flu/Influenza Vaccine',
    'COVID-19 Vaccine Administration',
    'Sepsis Awareness',
    "Parkinson's Disease Awareness",
    'EMIS Web — Coding, Templates & Reporting',
    'DOCMAN — Document Management & Coding',
    'Anima — Online Consultation Platform',
    'NHS e-Referral Service (e-RS)',
    'Microsoft Word, Excel, Outlook & PowerPoint',
    'PDF Generation — Clinical Reports & Protocols',
    'Care Certificate (15 Standards)',
    'Good Clinical Practice (GCP)',
    'Google AI Essentials for Healthcare',
    'NHS Information Governance & GDPR Compliance',
    'Safeguarding Adults — Level 3',
    'Safeguarding Children — Level 3',
    'Infection Control — Level 2',
    'Patient Manual Handling — Level 2',
    'Fire Safety',
    'Medical Terminology & Administration',
  ],
  researchAffiliations: [
    {
      title: 'Research Contributor — Black Health Legacy Research Programme',
      institution: 'National Institute for Health and Care Research (NIHR)',
      location: 'United Kingdom',
      year: 'Ongoing',
      tag: 'NIHR',
      blurb:
        'Contributing to NIHR-funded research advancing health outcomes, equity, and representation for Black communities across the UK.',
    },
  ],
};
